import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import {
  convertDate,
  copyText,
  scrollWindowTop,
} from "../../../utils/Common/Constant";
interface ResourceDetailsProps {
  contractDetails: any;
}
const ContractDetails = ({ contractDetails }: ResourceDetailsProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    scrollWindowTop();
  }, []);
  return (
    <div className="contractDetailSec">
      <div className="contractVendorDetail">
        <div className="profileMeta">
          <div className="row">
            <div className="col-md-12">
              <div className="detailHead">
                <p>{t("CONTRACT.VENDOR_DETAILS")}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.VENDOR")}</p>
                <h5 className="metaValue">
                  {contractDetails?.partnerCompanyName
                    ? contractDetails?.partnerCompanyName
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.VENDOR_EMAIL")}</p>
                <h5
                  className="metaValue cursorPointer"
                  onClick={() =>
                    copyText(contractDetails?.["partnerCompany.email"])
                  }
                >
                  {contractDetails?.["partnerCompany.email"]
                    ? contractDetails?.["partnerCompany.email"]
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.MANAGER")}</p>
                <h5 className="metaValue">
                  {contractDetails?.partnerUserName
                    ? contractDetails?.partnerUserName
                    : "-"}
                </h5>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-12">
              <div className="detailHead">
                <p>Resource details</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.RESOURCE_NAME")}</p>
                <h5 className="metaValue">
                  {`${
                    contractDetails?.applicantFirstName ||
                    contractDetails?.applicantLastName
                      ? contractDetails?.applicantFirstName +
                        " " +
                        contractDetails?.applicantLastName
                      : "-"
                  }`}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <p className="metaLabel">{t("CONTRACT.RESOURCE_EMAIL")}</p>
                <h5
                  className="metaValue cursorPointer"
                  onClick={() => copyText(contractDetails?.applicantEmailId)}
                >
                  {contractDetails?.applicantEmailId
                    ? contractDetails?.applicantEmailId
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.STATUS")}</p>
                <h5 className="metaValue">
                  {contractDetails?.status ? contractDetails?.status : "-"}
                </h5>
              </div>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-12">
              <div className="detailHead">
                <p>Commercial details</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.BILLING_CYCLE")}</p>
                <h5 className="metaValue">
                  {contractDetails?.meta?.billingCycle ?? "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.BUDGET")}</p>
                <h5 className="metaValue">
                  {contractDetails?.meta?.amount &&
                  contractDetails?.meta?.rateUnit
                    ? contractDetails?.meta?.amount +
                      " " +
                      contractDetails?.meta?.rateUnit
                    : "-"}
                </h5>
              </div>
            </div>

            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.PAYMENT_TERMS")}</p>
                <h5 className="metaValue">
                  {contractDetails?.meta?.paymentTerms
                    ? contractDetails?.meta?.paymentTerms
                    : "-"}
                </h5>
              </div>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-12">
              <div className="detailHead">
                <p>Other details</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.START_DATE")}</p>
                <h5 className="metaValue">
                  {contractDetails?.meta?.startDate
                    ? convertDate(contractDetails?.meta?.startDate, true, false)
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.DURATION")}</p>
                <h5 className="metaValue">
                  {contractDetails?.meta?.duration &&
                  contractDetails?.meta?.durationType
                    ? contractDetails?.meta?.duration +
                      " " +
                      contractDetails?.meta?.durationType
                    : "-"}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.SHIFT_TYPE")}</p>
                <h5 className="metaValue">
                  {`${contractDetails?.meta?.shiftStartTime ? contractDetails?.meta?.shiftStartTime : "-"} - ${contractDetails?.meta?.shiftEndTime ? contractDetails?.meta?.shiftEndTime : "-"} (${contractDetails?.meta?.timezone ? contractDetails?.meta?.timezone : "-"})`}
                </h5>
              </div>
            </div>
            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.CONTRACT_TYPE")}</p>
                <h5 className="metaValue">
                  {contractDetails?.contractType
                    ? contractDetails?.contractType
                    : "-"}
                </h5>
              </div>
            </div>

            <div className="col-md-3">
              <div className="w-100 mb-4">
                <p className="metaLabel">{t("CONTRACT.NOTICE_PERIOD")}</p>
                <h5 className="metaValue">
                  {contractDetails?.meta?.noticePeriodDays ?? "-"}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractDetails;
